<template>
  <div>
    <v-layout
      fill-height
      align-center
    >
      <!-- MESSAGES -->
      <v-text-field label="Поиск по слову/дате" />
      <v-spacer />
      <v-btn
        :disabled="!canAdd"
        color="primary"
        small
        icon
        @click="showMessageDialog"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-dialog
        v-model="messageDialog"
        persistent
        width="500"
      >
        <v-card>
          <v-card-text>
            <v-form>
              <v-textarea
                v-model="message"
                label="Сообщение"
              />

              <v-btn
                small
                color="primary"
                @click="addMessage"
              >
                Ок
              </v-btn>
              <v-btn
                small
                @click="messageDialog = false"
              >
                Отмена
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <div class="pa-1 messages-list">
      <v-list>
        <v-list-tile
          v-for="item in chat"
          :key="item.id"
          :style="getNodeStyle(item.node)"
          class="compact"
        >
          <v-list-tile-content
            :class="{ 'blue--text': item.author.id !== userRoles.Admin }"
          >
            <div>{{ item.text }}</div>
            <v-list-tile-sub-title>
              {{ item.author ? item.author.title : "" }}:
              {{ item.date | dateTime }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </div>
  </div>
</template>
<script>
import { createMessage } from "../../../backend/shipmentRequestsApi";
import { userRoles } from "../../../enums/user-roles.js";

export default {
  props: ["id", "disabled", "items"],
  data() {
    return {
      //items: [
      // {
      //   id: 1,
      //   owner: {
      //     id: 1,
      //     title: "Клиент"
      //   },
      //   date: "02.07.18 10:30",
      //   message: "Очень жду ответа по запросу",
      //   children: {
      //     id: 2,
      //     owner: {
      //       id: 2,
      //       title: "Сёмина"
      //     },
      //     date: "02.07.18 12:30",
      //     message: "Уточните город выгрузки",
      //     children: {
      //       id: 3,
      //       owner: {
      //         id: 1,
      //         title: "Клиент"
      //       },
      //       date: "02.07.18 16:30",
      //       message: "Лейпциг",
      //       children: null
      //     }
      //   }
      // },
      // {
      //   id: 4,
      //   owner: {
      //     id: 1,
      //     title: "Клиент"
      //   },
      //   date: "02.07.18 10:40",
      //   message: "Когда ждать ответа?",
      //   children: null
      // },
      // {
      //   id: 5,
      //   owner: {
      //     id: 3,
      //     title: "Система"
      //   },
      //   date: "02.07.18 10:30",
      //   message: "Внесены изменения в Запрос. Вер. 3.",
      //   children: null
      // }
      //],
      messageList: [],
      messageDialog: false,
      message: "",
    };
  },
  computed: {
    chat() {
      this.items.forEach((item, index) => {
        const count = 0;
        item.node = index + "-" + count;
        this.$set(this.messageList, index, item);
        if (item.children) {
          this.getMessageListItem(item.children, index, count + 1);
        }
      });
      return this.messageList;
    },
    canAdd() {
      return !this.disabled;
    },
    userRoles() {
      return userRoles;
    },
  },
  methods: {
    getMessageListItem(item, index, count) {
      if (!item) {
        return;
      }
      item.node = index + "-" + count;
      this.messageList.push(item);
      if (item.children) {
        this.getMessageListItem(item.children, index, count + 1);
      }
    },
    getNodeStyle(node) {
      return { paddingLeft: node.slice(-1) * 10 + "px" };
    },
    showMessageDialog() {
      if (this.canAdd) {
        this.messageDialog = true;
      }
    },
    async addMessage() {
      await createMessage(this.id, this.message);
      this.messageDialog = false;
      this.message = "";
      this.$emit("add");
    },
  },
};
</script>
